<template>
  <div>
    <div class="cont-xw clearfix">
      <div class="jg-head">产品图片</div>
      <div style="overflow: hidden" class="text-center">
        <div class="text-center">
          <img
            class="form-group col-md-6 col-xs-6 col-sm-6"
            style="float:none"
            src="../../common/images/BU04PB.jpg"
          />
          <div @click="riseup" class="btn btn-success btn-circle top text-center">上升</div>
          <div>
            <a href="#fast" type="button" class="btn btn-danger btn-circle download text-center">下载</a>
          </div>
        </div>
      </div>
      <div class="jg-head">产品概述</div>
      <p>IVF-BU04PB是在第二代UHF蓝牙读卡器BU01上面的第二种延伸，可通过Wifi接口与Wifi网络路由器连接自动上传数据到云平台。集成二维条码识读引擎以及UHF RFID读写模块，采用先进的CMOS影像识别技术，智能图像识别系统，可以轻松读取纸张、商品、屏幕等介质上的条码或者二维码，同时识别介质上的RFID信息。设备配带在手掌上，完美地解放了双手，手掌带上自动感应产品前方的标签（20CM范围内）进行读取，配套使用我司开发的平台使用，便于各种场合的应用。</p>
      <p>IVF-BU04PB is the second extension on the second-generation UHF Bluetooth card reader BU01, which can automatically upload data to the cloud platform through the Wifi interface and the Wifi network router connection. Integrated two-dimensional bar code reading engine and UHF RFID reading and writing module, using advanced CMOS image recognition technology, intelligent image recognition system, can easily read the bar code or two-dimensional code on paper, goods, screens and other media, and identify the media at the same time RFID information. The device is worn on the palm, which perfectly liberates both hands. The label on the front of the product (within 20CM) is automatically read in the palm, and it is used with the platform developed by our company, which is convenient for application in various occasions.</p>
      <div  class="jg-head">主要特点</div>
      <p>1）、条码、二维码、UHF标签均可读取</p>
      <p>2）、wifi通讯：联网时上报数据（实时数据与本地存储数据）；</p>
      <p>3）、离线存储：本地存储信息，有网络的时候可以自动链接上传</p>
      <p>4）、自带传感：可自动触发读取，不需要按键控制</p>
      <p>1) Bar code, QR code, UHF label can be read;</p>
      <p>2), wifi communication: report data when connected to the Internet (real-time data and local storage data);</p>
      <p>3) Offline storage: store information locally, and automatically link to upload when there is a network</p>
      <p>4) Self-contained sensor: can automatically trigger the reading, no button control is required</p>
      <div class="jg-head">参数规格</div>
      <p>1）、支持条码、二维码、超高频（UHF）标签协议ISO18000-6C</p>
      <p>2）、后台系统：可在后台服务器网址https://worksheet.xminnov.com上查看数据记录</p>
      <p>3）、通信接口：Wifi，采用扫描二维码配置存储当前模式；默认离线模式：拨钮开机（或扫描wifi共享二维码）连接Wifi网络，并上报离线状态所记录的2D/EPC+时间给后台服务器，无数据则关闭wifi；(平均功耗：70mA)
实时在线模式：拨钮开机（或扫描wifi共享二维码）连接Wifi网络，连接成功就一直打开实时上报记录给后台服务器，连接不成功就关闭wifi；(平均功耗：180mA)
</p>
      <p>4）、RFID读取距离：2-20cm（视标签大小而定）</p>
      <p>5）、1D/2D读取距离：20mm~230mm
识读码制：1D：UPC-A，UPC-E，EAN-8，EAN-13，Code 128， Code 39，Code 93，Code 11，Interleaved 2 of 5，Matrix 2 of 5，Standard 2 of 5（IATA），Codabar（NW-7），MSI Plessey，RSS，etc.
2D: QR Code, Data Matrix，PDF417，etc.
</p>
      <p>6）、读取方式：自动感应读取，也可按键触发读取</p>
      <p>7）、蜂鸣器：内置蜂鸣器，读取到标签响声</p>
      <p>8）、存储空间：120K字节，每条记录占用空间：二维码/EPC数据长度+24字节（例：EPC长度12字节，可存条数=120K÷36=3333条）</p>
      <p>9）、工作次数：按照5秒读取到一次计算可读取720次一小时</p>
      <p>10）、指示灯：电源指示灯、Wifi指示灯、状态指示灯</p>
      <p>11）、开关：拨扭开关</p>
      <p>12）、电池容量：1000mA可充电锂电池</p>
      <p>13）、充电方式：USB 5V/0.5A，充电4小时</p>
      <p>14）、材料：ABS+PC工程塑料，主体尺寸30mm*53mm*65mm</p>
      <p>15）、工作环境温度：-20℃~50℃</p>
      <p>16）、指示灯状态：
     白灯闪烁：表示未与服务器连接，工作中
     蓝灯闪烁：表示已连接服务器，工作中
     白灯蓝灯同时闪烁：表示低电量
     白灯蓝灯交替闪烁：表示网络信号较差
     红灯亮：表示在充电
</p>
      <p>17）、功耗：1.拨扭关机130uA;
2.拨扭开机，无震动30秒后待机1mA;
3.拨扭开机震动唤醒，检测无遮挡物30秒内工作下,Wifi在线180mA/Wifi离线70mA
4.拨扭开机震动唤醒检测遮挡物时，二维码/RFID射频读标时功耗1000mA。
</p>
      <p>1）、Support bar code, two-dimensional code, ultra-high frequency (UHF) label protocol ISO18000-6C</p>
      <p>2）、Back-end system: you can view data records on the back-end server website https://worksheet.xminnov.com</p>
      <p>3）、Default offline mode: turn on the button (or scan the wifi sharing QR code) to connect to the Wifi network, and report the 2D/EPC+ time recorded in the offline state to the background server, and turn off the wifi if there is no data; (average power consumption: 70mA)
Real-time online mode: turn on the button (or scan the wifi sharing QR code) to connect to the Wifi network. If the connection is successful, the real-time report record will be turned on to the background server, and the wifi will be turned off if the connection is unsuccessful; (average power consumption: 180mA)
</p>
      <p>4）、RFID reading distance: 2-20cm (depending on the size of the tag)</p>
      <p>5）、 1D/2D reading distance: 20mm~230mm
Code system: 1D: UPC-A, UPC-E, EAN-8, EAN-13, Code 128, Code 39, Code 93, Code 11, Interleaved 2 of 5, Matrix 2 of 5, Standard 2 of 5 ( IATA), Codabar (NW-7), MSI Plessey, RSS, etc.
2D: QR Code, Data Matrix, PDF417, etc.
</p>
      <p>6）、Reading method: automatic sensing reading, can also be triggered by pressing the key to read</p>
      <p>7）、buzzer: built-in buzzer, read the label sound</p>
      <p>8）、storage space: 120K bytes, each record takes up space: QR code/EPC data length + 24 bytes (for example: EPC length is 12 bytes, the number of records that can be stored = 120K ÷36=3333 items)</p>
      <p>9）、the number of work: according to 5 seconds to read once, it can be read 720 times an hour</p>
      <p>10）、Indicators: power indicator, Wifi indicator, status indicator</p>
      <p>11）、 switch: toggle switch</p>
      <p>12）、 battery capacity: 1000mA rechargeable lithium battery</p>
      <p>13）、Charging method: USB 5V/0.5A, charging for 4 hours</p>
      <p>14）、Material: ABS+PC engineering plastics, the main body size is 30mm*53mm*65mm</p>
      <p>15）、 Working environment temperature: -20℃~50℃</p>
      <p>16）、Status of indicator light:
     White light flashes: It means that it is not connected to the server and is working
     Blue light flashes: indicates that the server is connected, and it is working
     White light and blue light flashing at the same time: indicates low battery
     White light and blue light flashing alternately: indicates that the network signal is poor
     Red light on: it means charging
</p>
      <p>17）、power consumption: 1. Turn the knob to shut down 130uA;
2. Turn on the switch, and stand by 1mA after 30 seconds without vibration;
3. Toggle to turn on and vibrate to wake up, detect unobstructed objects and work within 30 seconds, Wifi online 180mA/Wifi offline 70mA
4. The power consumption of QR code/RFID radio frequency reading is 1000mA when the power is turned on and the vibration wakes up to detect obstructions.
</p>
      <div class="jg-head">产品应用</div>
      <p>掌上扫描器是一种用于仓库数据采集的理想工具，在配送、制造、行李处理、包裹运送和物流操作环节中使用。当在操作工人实际处理物品的时候（如拣选、包装、交付或移动货物），同时也负责收集数据，作为一个可穿戴的移动设备，操作工人的手完全无障碍地拿起和移动物品。.</p>
      <p>
          The handheld scanner is an ideal tool for warehouse data collection, used in distribution, manufacturing, baggage handling, parcel delivery and logistics operations. When the operator actually handles the items (such as picking, packaging, delivering or moving goods), it is also responsible for collecting data. As a wearable mobile device, the operator's hands can pick up and move the items completely without obstacles. .
      </p>
      <div class="jg-head">应用领域</div>
      <p>1.	仓库配送 Warehouse distribution</p>
      <p>2.	制造业 manufacturing</p>
      <p>3.	分配 distribution</p>
      <p>4.	包裹服务 Parcel service</p>
      <p>5.	机场行李处理 Airport baggage handling</p>
      <p>6.	废物处理服务 Waste treatment service </p>
       <div id="fast" class="jg-head">使用方法</div>
           <p>
               1.	使用设备扫描手机中的wifi共享二维码，设备自动会去连接该网络联网；例：账号ZHWLZC 密码05922220779 ，共享二维码内容为：WIFI:T:WPA;S:ZHWLZC;P:05922220779;;
           </p>
           <p>
               1. Use the device to scan the WiFi sharing QR code in the mobile phone, and the device will automatically connect to the network; for example: account ZHWLZC password 05922220779, the content of the shared QR code is: WIFI:T:WPA;S:ZHWLZC;P:05922220779 ;;
           </p>
        <div class="text-center">
          <img class="content" src="../../common/images/BU04PB-1.jpg" />
        </div>
        <p>2.扫描二维码或者UHF标签；</p>
        <p>2. Scan the QR code or UHF label;</p>
        <p>3.每台设备都有自己的设备ID，在平台上查看数据，网址是https://worksheet.xminnov.com
账号： zzm 密码：1234qwer
</p>
<p>
    Each device has its own device ID, check the data on the platform at https://worksheet.xminnov.com
Account: zzm Password: 1234qwer

</p>
        <div class="text-center">
          <img class="content" style="width: 100%;" src="../../common/images/BU04PB-2.jpg" />
        </div>
         <div id="fast" class="jg-head">Wifi模式配置二维码(Wifi mode configuration QR code)：</div>
         <div class="clearfix">
              <div class="col-md-6 col-xs-6  text-center">
                  <p>Wifi模式配置二维码<br/>(Wifi mode configuration QR code)：</p>
                  <p>Reconnect to the network server QR code（RECONNECT SERVER）</p>
               <img class="content" src="../../common/images/BU04PB-3.jpg" />
              </div>
               <div class="col-md-6 col-xs-6  text-center">
                   <p> 设备重启二维码 </p>
                   <p>SET WIFI MODE=1<br/>(Wifi在线/Wifi online)</p>
               <img class="content" src="../../common/images/BU04PB-4.jpg" />
              </div>
        </div>
         <div id="fast" class="jg-head">扫码模式配置二维码(Scan code mode to configure QR code)：</div>
          
          <div class="clearfix">
              <div class="col-md-4 col-xs-6 text-center">
                  <p>AT+BU04=1(二维码) </p>
                  <p>AT+BU04=1 (QR code) </p>
               <img class="content" src="../../common/images/BU04PB-5.jpg" />
              </div>
               <div class="col-md-4 col-xs-6 text-center">
                   <p> AT+BU04=2(二维码+RFID)</p>
                   <p>AT+BU04=2(QR code+RFID)  </p>
               <img class="content" src="../../common/images/BU04PB-6.jpg" />
              </div>
               <div class="col-md-4 col-xs-6 text-center">
                   <p>AT+BU04=3(二维码或RFID) </p>
                   <p>Default: AT+BU04=3 (QR code or RFID)</p>
               <img class="content" src="../../common/images/BU04PB-7.jpg" />
              </div>
             
</p>
          </div>
           <p>注：模式1只读条码/二维码；模式2同时读到1D/2D与RFID；模式3读到1D/2D或RFID的一种即可。</p>
<p>Note: Mode 1 read-only barcode/two-dimensional code; Mode 2 can read 1D/2D and RFID at the same time; Mode 3 can read either 1D/2D or RFID.</p>
            <br/>
            <br/>
            <div class="clearfix">
              <div class="col-md-4 col-xs-6  text-center">
                  <p>重新连接网络服务器二维码：</p>
                  <p>Reconnect to the network server QR code（RECONNECT SERVER）</p>
               <img class="content" src="../../common/images/BU04PB-8.jpg" />
              </div>
               <div class="col-md-4 col-xs-6  text-center">
                   <p> 设备重启二维码 </p>
                   <p>Device restart QR code（AT+RESET=1）</p>
               <img class="content" src="../../common/images/BU04PB-9.jpg" />
              </div>
               <div class="col-md-4 col-xs-6  text-center">
                   <p>配置设备ID二维码</p>
                   <p>Configure the device ID QR code（DEVICE ID:<span class="text-danger">‘ID15044100’</span>）</p>
               <img class="content" src="../../common/images/BU04PB-10.jpg" />
              </div>
             
          </div>
           <p>注：红色部分<span class="text-danger">‘ID15044100’</span>为ID号码内容。</p>
<p>Note: The red part <span class="text-danger">‘ID15044100’</span> is the ID number content.

</p>
          
<div id="fast" class="jg-head">下载</div>
          <ul>
        <li class="form-group">
          <FileDownload href="/static/IVF-BU/IVF-BU04PB常见问题及解答.docx">常见问题下载</FileDownload>
        </li>
        </ul>
    </div>
      <!-- 制作 新的组件 新组件：超链接地址 + download 属性 文本传输 download 判断属性 -->
  </div>
</template>

<script>
import FileDownload from "@/base/filedownload";
import QRDownload from "@/base/qrdownload";
import { riseup } from "@/common/js/riseup.js";
export default {
  data() {
    return {};
  },
  methods: {
    riseup() {
      riseup();
    },
  },
  components: { FileDownload, QRDownload },
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/BU04/PB.vue